/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GrandPrizeEntrySource } from './GrandPrizeEntrySource';
import {
    GrandPrizeEntrySourceFromJSON,
    GrandPrizeEntrySourceFromJSONTyped,
    GrandPrizeEntrySourceToJSON,
    GrandPrizeEntrySourceToJSONTyped,
} from './GrandPrizeEntrySource';
import type { PrizePool } from './PrizePool';
import {
    PrizePoolFromJSON,
    PrizePoolFromJSONTyped,
    PrizePoolToJSON,
    PrizePoolToJSONTyped,
} from './PrizePool';
import type { GrandPrizeDrawTiming } from './GrandPrizeDrawTiming';
import {
    GrandPrizeDrawTimingFromJSON,
    GrandPrizeDrawTimingFromJSONTyped,
    GrandPrizeDrawTimingToJSON,
    GrandPrizeDrawTimingToJSONTyped,
} from './GrandPrizeDrawTiming';

/**
 * Challenge-level Grand Prize configuration for simplified raffle management
 * @export
 * @interface ChallengeGrandPrize
 */
export interface ChallengeGrandPrize {
    /**
     * Whether Grand Prize is enabled for this challenge
     * @type {boolean}
     * @memberof ChallengeGrandPrize
     */
    enabled?: boolean;
    /**
     * Whether to distribute the prize immediately after drawing
     * @type {boolean}
     * @memberof ChallengeGrandPrize
     */
    autoDistributedRewards?: boolean;
    /**
     * Prize pool IDs for the Grand Prize drawing
     * @type {Array<string>}
     * @memberof ChallengeGrandPrize
     */
    prizePoolIds?: Array<string>;
    /**
     * Populated prize pool objects for display
     * @type {Array<PrizePool>}
     * @memberof ChallengeGrandPrize
     */
    prizePools?: Array<PrizePool>;
    /**
     * 
     * @type {GrandPrizeEntrySource}
     * @memberof ChallengeGrandPrize
     */
    entrySource?: GrandPrizeEntrySource;
    /**
     * 
     * @type {GrandPrizeDrawTiming}
     * @memberof ChallengeGrandPrize
     */
    drawTiming?: GrandPrizeDrawTiming;
    /**
     * Index of segment to auto-draw after (when drawTiming is AFTER_SEGMENT)
     * @type {number}
     * @memberof ChallengeGrandPrize
     */
    drawAfterSegmentIndex?: number;
    /**
     * Whether the Grand Prize has been distributed
     * @type {boolean}
     * @memberof ChallengeGrandPrize
     */
    hasDistributedRewards?: boolean;
    /**
     * Whether the Grand Prize has already been drawn
     * @type {boolean}
     * @memberof ChallengeGrandPrize
     */
    hasDrawn?: boolean;
    /**
     * Timestamp when Grand Prize was drawn
     * @type {number}
     * @memberof ChallengeGrandPrize
     */
    drawnAt?: number;
}



/**
 * Check if a given object implements the ChallengeGrandPrize interface.
 */
export function instanceOfChallengeGrandPrize(value: object): value is ChallengeGrandPrize {
    return true;
}

export function ChallengeGrandPrizeFromJSON(json: any): ChallengeGrandPrize {
    return ChallengeGrandPrizeFromJSONTyped(json, false);
}

export function ChallengeGrandPrizeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChallengeGrandPrize {
    if (json == null) {
        return json;
    }
    return {
        
        'enabled': json['enabled'] == null ? undefined : json['enabled'],
        'autoDistributedRewards': json['autoDistributedRewards'] == null ? undefined : json['autoDistributedRewards'],
        'prizePoolIds': json['prizePoolIds'] == null ? undefined : json['prizePoolIds'],
        'prizePools': json['prizePools'] == null ? undefined : ((json['prizePools'] as Array<any>).map(PrizePoolFromJSON)),
        'entrySource': json['entrySource'] == null ? undefined : GrandPrizeEntrySourceFromJSON(json['entrySource']),
        'drawTiming': json['drawTiming'] == null ? undefined : GrandPrizeDrawTimingFromJSON(json['drawTiming']),
        'drawAfterSegmentIndex': json['drawAfterSegmentIndex'] == null ? undefined : json['drawAfterSegmentIndex'],
        'hasDistributedRewards': json['hasDistributedRewards'] == null ? undefined : json['hasDistributedRewards'],
        'hasDrawn': json['hasDrawn'] == null ? undefined : json['hasDrawn'],
        'drawnAt': json['drawnAt'] == null ? undefined : json['drawnAt'],
    };
}

export function ChallengeGrandPrizeToJSON(json: any): ChallengeGrandPrize {
    return ChallengeGrandPrizeToJSONTyped(json, false);
}

export function ChallengeGrandPrizeToJSONTyped(value?: ChallengeGrandPrize | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'enabled': value['enabled'],
        'autoDistributedRewards': value['autoDistributedRewards'],
        'prizePoolIds': value['prizePoolIds'],
        'prizePools': value['prizePools'] == null ? undefined : ((value['prizePools'] as Array<any>).map(PrizePoolToJSON)),
        'entrySource': GrandPrizeEntrySourceToJSON(value['entrySource']),
        'drawTiming': GrandPrizeDrawTimingToJSON(value['drawTiming']),
        'drawAfterSegmentIndex': value['drawAfterSegmentIndex'],
        'hasDistributedRewards': value['hasDistributedRewards'],
        'hasDrawn': value['hasDrawn'],
        'drawnAt': value['drawnAt'],
    };
}

